<template>
  <AwlCard class="awl-modal-card" :border="border" box-shadow :title="title">
    <slot></slot>
  </AwlCard>
</template>

<script>

export default {
  name: 'awl-modal-card',
  components: {
    AwlCard: () => import('./AwlCard'),
  },
  props: {
    title: {
      type: String,
    },
    border: {
      type: Boolean,
      default: true,
    },
  },
};

</script>

<style lang="scss">

.awl-modal-card {
  margin-left: auto;
  margin-right: auto;
  max-width: 325px;

  @include media-breakpoint-up("sm") {
    max-width: 450px;
  }

  @include media-breakpoint-up("md") {
    max-width: 550px;
  }
}

</style>
